import { textAlignmentMap } from "../../content/configuration";
import React, { memo } from "react";
import Linkify from "react-linkify";

interface ParagraphsProps {
  /** Cypress/Playwright hook applied to the alignment wrapper. */
  dataCy?: string;
  text: string;
  textAlignment?: string;
}

/**
 * Renders newline-separated text as a stack of paragraphs with URLs linkified,
 * wrapped in a div carrying the requested text alignment.
 */
const Paragraphs = ({
  dataCy,
  text,
  textAlignment = "center",
}: ParagraphsProps) => (
  <div css={textAlignmentMap.get(textAlignment)} data-cy={dataCy}>
    {typeof text === "string"
      ? text.split("\n").map((paragraph, index) => (
          <span key={index}>
            <Linkify>{paragraph}</Linkify>
            <br />
          </span>
        ))
      : null}
  </div>
);

const MemoizedParagraphs = memo(Paragraphs);

export default MemoizedParagraphs;
